import { defineCustomElement } from "vue";
import { Register } from "..";
import F360Spinner from "./F360Spinner.ce.vue";

const tag = "vc-spinner";

const _register: Register = {
  register() {
    customElements.get(tag) ||
      customElements.define(tag, defineCustomElement(F360Spinner));
  }
};

export default _register;
